import { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import Loader from 'react-loader-spinner'
import { eduPaymentSummary, eduSponsorshipEnrol } from 'services/api/course_payment/index'
import CustomHelmet from 'components/smart/CustomHelmet'

const SponsorshipInquiry = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [courseData, setCourseData] = useState(null)

    const getCourseData = async (id) => {
        try {
            setLoading(true)
            const res = await eduPaymentSummary(id)
            if (res.data.payment_settled === 1) {
                navigate('/upskill-payment')
                return
            }
            setCourseData(res.data)
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false)
        }
    }

    const handleEnrol = async () => {
        try {
            setLoading(true)
            await eduSponsorshipEnrol(id)
            navigate(`/enrolment-success/${id}`)
        } catch (e) {
            console.error('Enrolment error full object:', e)
            alert(`Failed to record YP enrolment: ${e?.data?.message || e?.message || e?.statusText || 'Unknown error'}`)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getCourseData(id)
    }, [id])

    if (loading || !courseData) {
        return (
            <div className="flex h-screen items-center justify-center">
                <Loader type="Oval" color="#09b7b7" height={55} width={55} />
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-adx-gray px-4 py-12">
            <CustomHelmet title="Sponsorship Inquiry | adnexio EDU" />
            <div className="mx-auto max-w-2xl text-center">
                <div className="mb-12 flex justify-center">
                    <img src={'/logo_adnexio.png'} className="h-10" alt="adnexio_logo" />
                </div>

                <div className="rounded-2xl bg-white p-4 shadow-sm lg:p-8">
                    <div className="mb-8 flex items-center justify-start space-x-4">
                        <img
                            src={courseData.course_logo || "/logo_adnexio.png"}
                            alt="course_logo"
                            className="h-16 w-16 rounded-xl object-contain"
                        />
                        <h2 className="text-xl font-bold text-[#F3BF3A] text-left">{courseData.course_title}</h2>
                    </div>

                    <div className="mb-8 h-px bg-gray-200" />

                    <h3 className="mb-2 text-2xl font-bold text-gray-900">Yayasan Peneraju Sponsorship</h3>
                    <p className="mb-8 text-gray-600">
                        Thank you for your interest in the Yayasan Peneraju sponsorship program.
                    </p>

                    <div className="mb-8 rounded-xl bg-gray-50 p-6 lg:p-10">
                        <p className="mb-2 text-sm text-gray-500 uppercase tracking-wide">Course Price</p>
                        <p className="mb-4 text-3xl font-bold text-[#F3BF3A] lg:text-4xl">
                            RM 6,000
                        </p>
                        <p className="mx-auto max-w-sm text-sm text-gray-500">
                            Our team will contact you to discuss the sponsorship application process and eligibility requirements.
                        </p>
                    </div>

                    <div className="flex flex-col space-y-4">
                        <button
                            onClick={() => window.open('https://financingscheme.adnexio.jobs/', '_blank')}
                            className="w-full rounded-full bg-[#F3BF3A] py-3 font-semibold text-gray-900 shadow-sm transition-colors hover:bg-[#e2b030] focus:outline-none"
                        >
                            Get Contact
                        </button>
                        <button
                            // onClick={handleEnrol}
                            // className="w-full rounded-full border border-[#B57D00] bg-[#FDF7DF] py-3 font-semibold text-[#B57D00] shadow-sm transition-colors hover:bg-cream-100 focus:outline-none"
                            // # Uncomment the above code if YP is ready and as at 6 March 2026, we need to temporary disable this function course admin & backend need to work on sponsorship table activation 
                            className="w-full rounded-full border border-gray-200 bg-gray-200 py-3 font-semibold text-gray-400 shadow-sm transition-colors hover:bg-cream-100 focus:outline-none"
                        >
                            Enrol Now
                        </button>
                    </div>

                    <div className="mt-8">
                        <button
                            onClick={() => navigate(`/funding-options/${id}`)}
                            className="text-sm font-medium text-blue-500 hover:underline"
                        >
                            Back To Funding Options
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SponsorshipInquiry
